import { useWindowSize } from "@uidotdev/usehooks";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

export const BenifitItem = ({ image, titleheader, title }) => {
  const { i18n } = useTranslation();
  const { width } = useWindowSize();
  return (
    <div
      className={` mr-[30px] rounded-[20px] sm:mr-0 ${i18n.language === "en" ? (width > 1230 ? "h-[468px]" : width > 1023 ? "h-[560px]" : width > 870 ? "h-[450px]" : width > 600 ? "h-[324px]" : "h-[490px]") : "min-h-[520px]"}  relative overflow-hidden  sm:mr-0`}
    >
      <div className="hover-effect mb-[1px] flex flex-col rounded-[20px]  bg-white p-[20px] hover:border-t-[10px] ">
        <div className="h-[100px] w-[100px] rounded-[50px]  shadow-benefits">
          <img className="p-[25px]" src={image} alt="Benifit" />
        </div>
        <div className="mt-[25px] flex flex-col gap-[10px]">
          <h3 className="bg-[-100%] text-[24px] font-semibold text-[--color-hover]">
            {titleheader}
          </h3>
          <p className="text-4 font-normal text-[--color-text] group-hover:animate-text">
            {title}
          </p>
        </div>
      </div>
    </div>
  );
};
BenifitItem.propTypes = {
  image: PropTypes.string,
  titleheader: PropTypes.string,
  title: PropTypes.string,
};
